import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";
import { SendToTrackingService } from "@/api/handlers/errors";

export interface ReuseDetail {
  reuseDetailId: number | null;
  getNewPicture: boolean;
}

export interface ReuseAddress {
  prefName: string;
  locationFull: string;
  chibanKaokuNumber: string;
  reusePicture: ReuseDetail | null;
}

// 物件概要書作成APIリクエストのインターフェース
export interface CreatePropertySheetAPIRequest {
  address: string;
  latitude: number;
  longitude: number;
  chiban: ReuseAddress | null;
  primaryKaokuNumber: ReuseAddress;
  kaokuNumbers: ReuseAddress[];
  pastDays: number | null;
}

/**
 * 物件概要書の作成APIを実行する
 * HTTPマルチパートリクエストを使用してバックエンドにデータを送信する
 *
 * @param {AxiosInstance} apiClient - HTTPリクエストを行うためのAxiosのインスタンス
 * @returns {SWRMutationResponse} データ更新関数を含むSWRオブジェクト
 */
export const CreatePropertySummaryAPI = (
  apiClient: AxiosInstance
): SWRMutationResponse<{ status: string } | null, never, string, FormData> => {
  const fetcher = async (
    url: string,
    { arg }: { arg: FormData }
  ): Promise<{ status: string } | null> => {
    try {
      const response = await apiClient.post<{ status: string }>(url, arg, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        if (
          (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
        ) {
          SendToTrackingService(error);
        }
      }
    }
    return null;
  };

  return useSWRMutation("/property-summary/", fetcher, {
    revalidate: false,
  });
};

export default CreatePropertySummaryAPI;
